
import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Campaign } from "@/types/campaigns";
import { getCampaignTypeDisplayName } from "@/utils/campaignTypeTranslations";

interface PublishCampaignDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  campaign: Campaign | null;
}

const PublishCampaignDialog = ({
  open,
  onOpenChange,
  onConfirm,
  campaign
}: PublishCampaignDialogProps) => {
  if (!campaign) return null;

  const today = new Date();
  const startDate = new Date(campaign.start_date);
  const isStartingToday = startDate.toDateString() === today.toDateString();
  const willBeActive = isStartingToday;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Publicar Campanha</AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <div>
              Tem certeza que deseja publicar a campanha <strong>"{campaign.name}"</strong>?
            </div>
            
            <div className="bg-blue-50 p-3 rounded-md">
              <p className="text-sm font-medium text-blue-900">
                Status após publicação:
              </p>
              <p className="text-sm text-blue-700">
                {willBeActive 
                  ? "🟢 Ativa (será aplicada imediatamente)" 
                  : "🟡 Agendada (será ativada automaticamente na data de início)"
                }
              </p>
            </div>

            <div className="text-sm text-gray-600">
              <p><strong>Período:</strong> {new Date(campaign.start_date).toLocaleDateString('pt-BR')} - {new Date(campaign.end_date).toLocaleDateString('pt-BR')}</p>
              <p><strong>Tipo:</strong> {getCampaignTypeDisplayName(campaign.type)}</p>
              <p><strong>Produto:</strong> {campaign.product === "cashback" ? "Cashback" : "Indique e Ganhe"}</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-brand-teal hover:bg-brand-teal/90">
            Publicar Campanha
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default PublishCampaignDialog;
